import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { Button } from 'react-bootstrap'
import { Icons, Util } from '@leverege/api-attributes'
import Path from '@leverege/path'
import { Dialogs } from '@leverege/ui-elements'

import { TextInput, Icon } from '~/views'
import ComponentAttrs from '~/editors/attributes'

import { AttributeUpdater } from '~/actions'
import { removeAttribute } from '~/actions/BlueprintActions'
import RemoveDialog from './RemoveDialog'

import style from './style.css'

class AttributeItem extends React.Component {
  
  static propTypes = {
    item : PropTypes.object,
    blueprint : PropTypes.object,
    onSelect : PropTypes.func,
    selectedItem : PropTypes.object
  }

  onSelect = () => {
    const { onSelect, item } = this.props 
    if ( onSelect ) {
      onSelect( item )
    }
  }

  onFocus = () => this.onSelect()

  onNameChange = ( value, error ) => {
    const { item, dispatch, blueprint } = this.props 
    if ( !error ) {
      const attr = item.attribute
      const path = Path( attr.path )
      path.changeLast( value )
      AttributeUpdater( dispatch, blueprint, attr )
        .set( 'path', path.path() )
        .done()
    }
  }

  renderButtons = ( selected ) => {
    return (
      <div className={classNames( style.attributeButtons, selected && style.selected )}>
        <Button 
          bsStyle="link"
          bsSize="large"
          className={classNames( style.attributeButton, style.remove )}
          tabIndex="-1"
          onClick={this.showRemoveAttribute}> 
          <i className="fa fa-fw fa-trash" />
        </Button>
      </div>
    )
  }

  showRemoveAttribute = () => {
    const { item, blueprint } = this.props
    const attribute = item.attribute
    Dialogs.show( {
      component : RemoveDialog,
      props : {
        attribute,
        blueprint,
        onOkay : this.onRemove
      }
    } )
  }

  onRemove = () => {
    const { dispatch, blueprint, item } = this.props 
    dispatch( removeAttribute( blueprint, item.attribute ) )
  }

  render() {
    const { item, selectedItem } = this.props 

    const acceptKey = ComponentAttrs.EventKeyValidator;

    const desc = item.desc === null ? 
      null :                   
      <div className={style.attributeSubtitle}>{item.desc}</div>

    const attrIcon = Icons.getIcon( item.attribute )
    const selected = item === selectedItem
    const cn = classNames( style.attributeArea, selected ? style.selected : null )
    const buttons = this.renderButtons( selected )

    let collectionInfo = null
    if ( item.name.endsWith( '@' ) ) {
      collectionInfo = 'collection'
    } else if ( item.name.endsWith( '*' ) ) {
      collectionInfo = 'array'
    }

    return (
      <div className={style.attributeGroup}>
        <div className={cn} >
          <div onClick={this.onSelect}>
            <div className={style.attributeNames}>
              <Icon className={style.icon} icon={attrIcon} showEmpty />
              <div className={style.attribute}>
                <TextInput className={style.attributeTitle} 
                  onChange={this.onNameChange}
                  validator={Util.isPathValid}
                  acceptKey={acceptKey}
                  value={item.name} />
                <div className={style.collectionInfo}>
                  {collectionInfo}
                </div>
              </div>
              {desc}
            </div>
          </div>
          {buttons}
        </div>
      </div>
    )
  }
}

export default connect()( AttributeItem )
